import { XML_ShiftRect } from "./XML_ShiftRect.js";
import { XML_Param4 } from "./XML_Param4.js";

export function XML_AddBoundingRect(boundingRect, drawElement) {
  var s = drawElement.GetStream();
  XML_ShiftRect(boundingRect, drawElement, null);
  var top = drawElement.ConvertY(boundingRect.fTop);
  var width = boundingRect.fRight - boundingRect.fLeft;
  var height = boundingRect.fBottom - boundingRect.fTop;
  XML_Param4("b", boundingRect.fLeft, top, width, height, drawElement);
}
